<template>
    <div class="box my-chart">
        <canvas id="myChart" width="100" height="50"></canvas>
    </div>
</template>

<script>
import  Chart from  'chart.js';
import { mapGetters } from 'vuex';
import {dataService} from '../shared/data';
    export default {
        props: {
            sampleIds: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                chart: undefined,
                scatterChartData: undefined,                
            }
        },
        watch: {
            'sampleIds' : {
                immediate: true,
                handler() {
                    // console.log("samples to show updated");
                    // console.log(newValue);
                    // console.log(oldValue);
                    this.updateDatasets();
                }
            }
        },
        computed: {
            ...mapGetters(['getSamplesByIds']),
        },
        methods: {
            getRandomInt(max) {
                return Math.floor(Math.random() * Math.floor(max));
            },
            getColor(){
                const delta = this.getRandomInt(120);                
                const color = {
                    r : delta > 50 ?  124 + delta : 124 -  delta,
                    g : delta > 50 ? 124 - delta : 124 + delta,
                    b : delta > 50 ? 124 - delta : 124 + delta
                };
                return color;
            },
            updateDatasets()
            {
                if(!this.$data.scatterChartData || !this.$data.chart)
                    return;
                
                if(this.$data.scatterChartData.datasets && this.$data.scatterChartData.datasets.length>0)
                {
                    this.$data.scatterChartData.datasets = [...this.$data.scatterChartData.datasets.filter(x=>this.sampleIds.includes(x.id))];
                }
                else{
                    this.$data.scatterChartData.datasets = [];
                }
                
                const sampleIdsToAdd = this.sampleIds.filter(x=>
                    !this.$data.scatterChartData.datasets.map(ds=>ds.id)
                        .includes(x)
                );
                const samplesToAdd = this.getSamplesByIds(sampleIdsToAdd);
                const datasetsToAdd = samplesToAdd.map(x=> 
                {
                    const color = this.getColor();
                    const dataset = 
                    {  
                        id : x.id,                  
                        label: x.name,
                        xAxisID: 'x-axis-1',
                        yAxisID: 'y-axis-1',
                        borderColor: `rgb(${color.r}, ${color.g}, ${color.b})`,
                        //backgroundColor: `rgb(${color.r}, ${color.g}, ${color.b}, 0.5)`,
                        showLine: true, 
                        //backgroundColor: 'rgba(54, 162, 235,0.5)',                        
                        data: x.sampleData.map(d=> { 
                            const data = {x: d.u, y:d.i};
                            return data;
                        })
                    };

                    return dataset;
                });

                if(datasetsToAdd.length>0)
                    this.$data.scatterChartData.datasets = this.$data.scatterChartData.datasets.concat(datasetsToAdd);

                this.$data.chart.update();
            }
        },
        mounted () {
            var ctx = document.getElementById('myChart').getContext('2d');
            this.scatterChartData = {
                datasets : [{
                        label: 'My First dataset',
                        xAxisID: 'x-axis-1',
                        yAxisID: 'y-axis-1',
                        borderColor: 'rgb(54, 162, 235)',
                        //backgroundColor: 'rgba(54, 162, 235,0.5)',
                        showLine: true, 
                        data: dataService.getDataExample()                       
                        }, 
                        {
                        label: 'My Second dataset',
                        xAxisID: 'x-axis-1',
                        yAxisID: 'y-axis-2',
                        borderColor: 'rgb(66, 187, 81)',
                        //backgroundColor: 'rgba(66, 187, 81, 0.5)',
                        showLine: true, 
                        //data: dataService.getSampleData("bfe51b26-61b1-488a-bc22-dfcc6e92ad5b")
                        data: dataService.getDataExample()                       
                        
                    }]
                };        
            this.chart = Chart.Scatter(ctx, {
                type: 'line',
                data: this.scatterChartData,
                options: {
                    responsive: true,
                    hoverMode: 'nearest',
                    intersect: true,
                    title: {
                        display: true,
                        text: 'I-V chart'
                    },
                    scales: {
                        xAxes: [{
                            position: 'bottom',
                            gridLines: {
                                zeroLineColor: 'rgba(0,0,0,1)'
                            }
                        }],
                        yAxes: [{
                            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                            display: true,
                            position: 'left',
                            id: 'y-axis-1',
                        }, {
                            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                            display: true,
                            position: 'right',
                            reverse: true,
                            id: 'y-axis-2',

                            // grid line settings
                            gridLines: {
                                drawOnChartArea: false, // only want the grid lines for one axis to show up
                            },
                        }],
                    }
                }
            });

            this.chart.update();
        },
    }
</script>

<style lang="css" scoped>   
    
    .my-chart{
        max-width: 800px;

    }   
    
</style>